import { Button } from '@sloyd/ui';

import { Loading, RecordDot, Running, Wrapper } from './ExitRealtime.style';

export type ExitRealtimeProps = {
  isReady?: boolean;
  onClick: () => void;
};

export function ExitRealtime(props: ExitRealtimeProps) {
  const { isReady } = props;

  const text = isReady ? 'Listening...' : 'Getting ready...';

  function renderLoading() {
    return <Loading>{text}</Loading>;
  }

  function renderRunning() {
    return (
      <Running>
        <RecordDot />
        {text}
      </Running>
    );
  }

  return (
    <Wrapper className='ExitRealtime-wrapper' data-testid='ExitRealtime-wrapper'>
      {isReady ? renderRunning() : renderLoading()}
      <Button size='sm' variant='outline' color='pink' onClick={props.onClick}>
        Exit Realtime
      </Button>
    </Wrapper>
  );
}

export default ExitRealtime;
